import { useEffect, useState } from 'react';
import { StorageKeys } from 'src/constants/storageKeys';
import { setIntoLocalStorage } from 'src/internals/local-storage';
import { getNavBarStateWIthFallback } from 'src/utils/navbar.utils';

export const useNavBarCollapseState = (subId: string, initialCollapsed: boolean) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);

  useEffect(() => {
    if (subId !== undefined) {
      const collapsedStorageValue =
        localStorage.getItem(StorageKeys.navbar) ??
        '{shouldCollapse: false, overrideOldValue: true}';

      const collapsedValue = getNavBarStateWIthFallback(subId, collapsedStorageValue);

      if (collapsedValue.overrideOldValue) {
        localStorage.removeItem(StorageKeys.navbar);
        setIntoLocalStorage(StorageKeys.navbar, subId, collapsedValue.shouldCollapse);
      }

      setCollapsed(collapsedValue.shouldCollapse);
    }
  }, [initialCollapsed, subId]);

  return [collapsed, setCollapsed] as const;
};
